export default __webpack_public_path__ + "static/media/reward1_detail_3.f74f2e31.png";